import { render, staticRenderFns } from "./details-gc.vue?vue&type=template&id=581955c6&"
import script from "./details-gc.vue?vue&type=script&lang=js&"
export * from "./details-gc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports